export default "static/src/images/telt-logo-CMYK.gif";